import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersApi,
  partnersApiKeys,
  type PartnerAccountBody,
} from '@/api/routes/partners/partners.api';

/** Edit and resubmit; the onboarding form owns the error UX. */
export const usePartnersUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PartnerAccountBody) => partnersApi.update(data),
    meta: { showUserMessage: false },
    onSuccess: (response) => {
      queryClient.setQueryData(partnersApiKeys.me(), response.data);
      return queryClient.invalidateQueries({ queryKey: partnersApiKeys.all });
    },
  });
};
